import { JIRA_PROJECT_KEY_ANNOTATION, DEFAULT_JIRA_QUERY_ANNOTATION } from '../constants.esm.js';

const isJiraAvailable = (entity) => Boolean(entity?.metadata.annotations?.[JIRA_PROJECT_KEY_ANNOTATION]);
const hasJiraQuery = (entity) => Boolean(entity?.metadata.annotations?.[DEFAULT_JIRA_QUERY_ANNOTATION]);

export { hasJiraQuery, isJiraAvailable };
//# sourceMappingURL=Router.esm.js.map
